<app-split-pane
  storageKey="split.design"
  [initialLeftRatio]="0.7"
  [collapseBreakpointPx]="1024"
  [collapsedOnSmallScreens]="true"
>
  <ng-container left>
    <app-split-pane-vertical storageKey="split.design.left" [initialTopRatio]="0.7">
      <ng-container top>
        <app-chat
          [suggestions]="designSuggestions"
          [context]="designContext"
          [initialMessages]="designStore.chatMessages()"
          (messagesChange)="onChatMessagesChange($event)"
          (messageCreated)="onChatMessageCreated($event)"
          placeholder="Start describing your design..."
        ></app-chat>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="design.chat"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>

  <ng-container right>
    <app-split-pane-vertical storageKey="split.design.right" [initialTopRatio]="0.7">
      <ng-container top>
        <div class="design-workspace">
          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h2 class="h4 mb-1">Design</h2>
            <p class="text-muted mb-0">
              Define visual direction, accessibility goals, and UX priorities to generate a practical design brief.
            </p>
          </section>

          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h3 class="h5 mb-3">Design Inputs</h3>

            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Design system/style</label>
                <select class="form-select" [(ngModel)]="designForm.designSystem">
                  <option value="">Select a style...</option>
                  @for (option of designSystemOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Accessibility target</label>
                <select class="form-select" [(ngModel)]="designForm.accessibilityTarget">
                  <option value="">Select a target...</option>
                  @for (option of accessibilityOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </div>
            </div>

            <div class="mt-3">
              <label class="form-label">UX priorities</label>
              <div class="priority-grid">
                @for (priority of uxPriorityOptions; track priority) {
                  <label class="form-check priority-item">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="designForm.uxPriorities.includes(priority)"
                      (change)="onPriorityToggle(priority, $event)"
                    />
                    <span class="form-check-label">{{ priority }}</span>
                  </label>
                }
              </div>
            </div>

            <div class="mt-3 d-flex align-items-center gap-2">
              <button
                class="btn btn-primary"
                type="button"
                (click)="generateDesignBrief()"
                [disabled]="!canGenerateBrief"
              >
                @if (generating) {
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Generating...
                } @else {
                  Generate Design Brief
                }
              </button>
            </div>

            @if (validationError) {
              <div class="alert alert-danger mt-3 mb-0">{{ validationError }}</div>
            }
            @if (successMessage) {
              <div class="alert alert-success mt-3 mb-0">{{ successMessage }}</div>
            }
          </section>

          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h3 class="h5 mb-3">Design Brief</h3>

            @if (!hasGeneratedBrief) {
              <div class="text-muted small">
                No brief generated yet. Complete inputs and click <span class="fw-semibold">Generate Design Brief</span>.
              </div>
            } @else {
              <div class="brief-grid">
                <article class="brief-item">
                  <div class="brief-label">Design system</div>
                  <div class="brief-value">{{ designForm.designSystem }}</div>
                </article>
                <article class="brief-item">
                  <div class="brief-label">Accessibility target</div>
                  <div class="brief-value">{{ designForm.accessibilityTarget }}</div>
                </article>
                <article class="brief-item brief-item--full">
                  <div class="brief-label">UX priorities</div>
                  <ul class="mb-0">
                    @for (priority of designForm.uxPriorities; track priority) {
                      <li>{{ priority }}</li>
                    }
                  </ul>
                </article>
              </div>
            }
          </section>
        </div>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="design.main"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>
</app-split-pane>
